import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { fetchCompanyProfilesList, setSelectedCompanyProfile } from 'modules/common/actions';
import CompaniesComponent from 'modules/companies/components/CompaniesComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const CompaniesContainer = ({ companiesListApiCallBody }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [companiesListApiCallParams, setCompaniesListApiCallParams] =
    useState(companiesListApiCallBody);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPageFilter, setSelectedPageFilter] = useState(1);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const submitSearchQuery = (reset, value) => {
    setSelectedPageFilter(1);

    const body = {
      data: {
        ...companiesListApiCallParams,
      },
    };

    if (value) body.data.searchKeyword = value;
    if (reset) delete body.data.searchKeyword;

    setCompaniesListApiCallParams(body.data);
    dispatch(fetchCompanyProfilesList(body));
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleAddCompanyBtnClick = () => {
    navigate('/addCompany');
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        submitSearchQuery(false, value);
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      submitSearchQuery(true);
  };

  const handleCompaniesPaginationClick = selectedPageNumber => {
    setSelectedPageFilter(selectedPageNumber);

    const data = {
      ...companiesListApiCallParams,
    };
    data.page = selectedPageNumber;
    const body = {
      data,
    };

    dispatch(fetchCompanyProfilesList(body));
  };

  const handleCompanyClick = company => {
    const { name, email, companyProfileKey, profileHashedKey } = company;

    sessionStorage.setItem('companyNameAuthCookie', name);
    sessionStorage.setItem('companyEmailAuthCookie', email);
    sessionStorage.setItem('companyProfileKeyAuthCookie', companyProfileKey);
    sessionStorage.setItem('companyProfileHashedKeyAuthCookie', profileHashedKey);

    dispatch(
      setSelectedCompanyProfile({
        email,
        token: companyProfileKey,
      }),
    );

    navigate('/posts');
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <CompaniesComponent
      searchQuery={searchQuery}
      selectedPageFilter={selectedPageFilter}
      handleAddCompanyBtnClick={handleAddCompanyBtnClick}
      handleSearchBarInputChange={handleSearchBarInputChange}
      handleCompaniesPaginationClick={handleCompaniesPaginationClick}
      handleCompanyClick={handleCompanyClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

CompaniesContainer.propTypes = {
  companiesListApiCallBody: PropTypes.shape({}).isRequired,
};

CompaniesContainer.defaultProps = {};

export default CompaniesContainer;
